import { IConstantRefType, IDiscountType, IRefRuleType } from './IPlan.types';

export const DISCOUNT_TYPE: IDiscountType = {
  USAGE: 'USAGE_ONLY',
  USAGE_SUPPLY: 'USAGE_AND_SUPPLY',
};

export const CHARGES = {
  DAILY_SUPPLY_CHARGE: 'DAILY SUPPLY CHARGE',
  PEAK_USAGE: 'PEAK USAGE',
  OFF_PEAK_USAGE: 'OFF PEAK USAGE',
};

export const REF_RULE: IRefRuleType = {
  DMO: 'DMO',
  VDO: 'VDO',
  MINISTRY: 'Ministry',
  UNREGULATED: 'Unregulated',
};

export const REF_TYPE: IConstantRefType = {
  USAGE: 'Usage',
  USAGE_SUPPLY: 'Usage and Supply',
};

export const REF_TARIFF_TYPE = {
  TIME_OF_USE: 'time of use',
  TIME_OF_USE_WITH_CONTROLLED_LOAD: 'time of use with control load',
  FLAT_RATE: 'flat rate',
  FLAT_RATE_WITH_CONTROLLED_LOAD: 'flat rate with control load',
};

export enum MeterStatus {
  FOUND = 'FOUND',
  BELOW_THRESHOLD = 'BELOW_THRESHOLD',
  NOT_FOUND = 'NOT_FOUND',
  NOT_SERVICEABLE = 'NOT_SERVICEABLE',
}
